enum AcfuProgressiveDisclosureParameters {
  DEFAULT_WINDOW_IN_DAYS = 3,
  EXPANSION_STEP_IN_DAYS = 7,
  MAX_WINDOW_IN_DAYS = 28,
}

export { AcfuProgressiveDisclosureParameters }
